module.exports = __webpack_public_path__ + "media/images/pokerroom/partypoker/step3-full-843eef0682965847e49e61e023cd2792.jpg";